// Información de build generada automáticamente
export const BUILD_DATE = '26-01-2026 10:08:01';
export const BUILD_HASH = '325poyorzus';
export const APP_VERSION = '0.0.0';
export const BUILD_TIMESTAMP = 1769432881940;

// Para debugging en consola
console.log('%cℹ️ Build Info', 'color: #2196F3; font-weight: bold;', {
  buildDate: '26-01-2026 10:08:01',
  buildHash: '325poyorzus',
  appVersion: '0.0.0',
  timestamp: 1769432881940
});
